import { apiFetch } from "./client";

export const fetchRedeemProducts = () =>
  apiFetch("/enduser/redeem/", {
    credentials: "include",
  });

export const claimRedeemProduct = async (itemId) => {
  const base = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
  const response = await fetch(`${base}/enduser/redeem-product/${itemId}/claim/`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    // Ignore non-JSON or empty body responses.
  }

  if (!response.ok) {
    const errorMessage =
      data?.message || data?.detail || "Unable to claim this product.";
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  return {
    status: response.status,
    data,
  };
};
